import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import { LogenInstance, LotteInstance } from "../instance";
import { barcodeAddState } from "../../stores/addbarcode/barcodeAddState";

// TODO 운송장 추가등록 점소정보 받아오는 API
export const useGetStatus = (date) => {
  // NOTE 상태 변수 선언
  const login = useRecoilValue(loginState); // 로그인
  const setAddData = useSetRecoilState(barcodeAddState); // 운송장 추가등록 점소정보

  // TODO 성공 시 함수
  const handleSuccess = (data) => {
    if (data.result === "00" || data.result === "77") {

      let setData = {
        emp_cd: "",
        tg_bran_cd: "",
        pob: "",
        car_num: "",
      };

      const filteredData = data.data.filter(item => item.tm_dv === "60")[0] || {
        emp_cd: "",
        tg_bran_cd: "",
        pob: "",
        car_num: "",
      };
      setData = {
        emp_cd: filteredData.emp_cd ? filteredData.emp_cd.split(",") : "",
        tg_bran_cd: filteredData.tg_bran_cd ? filteredData.tg_bran_cd.split(",") : "",
        pob: filteredData.pob ? filteredData.pob.split(",") : "",
        car_num: filteredData.car_num ? filteredData.car_num.split(",") : "",
      };
      setAddData(setData);
    }
  };

  // TODO API 통신 결과
  const mutationOptions = {
    onSuccess: handleSuccess, // 성공 시
    onError: (error) => { // 실패 시
      console.log(error);
    }
  };

  // TODO API 리퀘스트 정보
  const postData = () => {
    const instance = login.company === "LOGEN" ? LogenInstance : LotteInstance;
    return instance.post("/watcher/status", {
      api: "status",
      data: [
        {
          bran_cd: login.branchCode,
          scandate: date
        }
      ]
    });
  };

  return useMutation("getRegisterModalStatus", postData, mutationOptions);
};
